export default {"src":"/_next/static/media/info.59945e6c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};